import {
  BookingData,
  BookingTool,
  Organisation,
  Step,
} from "../../AppDataProvider/types";
import {
  ResourceAllocationType,
  ResourceSelectionMode,
} from "../../GeneratedGraphQL";

import { isFeatureFlagEnabledForOrganisation } from "..";

type GetBookingQuestionsPreviousStepOpts = {
  bookingData: BookingData;
  bookingTool: BookingTool;
  organisation: Organisation;
};

export const getBookingQuestionsPreviousStep = ({
  bookingData,
  bookingTool,
  organisation,
}: GetBookingQuestionsPreviousStepOpts): Step => {
  const { recurringBooking, service } = bookingData;
  const { resourceSelectionMode } = bookingTool;

  /**
   * If we have been provided a resourceId in the url params,
   * we do not want to return to the resource step. We also do
   * not want to return to the resource step if there is only
   * one resource to choose from.
   */
  const urlParams = new URLSearchParams(window.location.search);
  const preFillResourceId = urlParams.get("resourceId");
  const availableResources = bookingData.resourceIds;

  const comboMapAvailability = bookingTool.organisationAvailabilityFlow;

  if (comboMapAvailability) {
    return "locationAvailability";
  }

  if (
    resourceSelectionMode !== ResourceSelectionMode.Disabled &&
    service?.resourceAllocationType === ResourceAllocationType.Any &&
    !organisation.resourceSelectionBeforeAvailability &&
    !preFillResourceId &&
    bookingData.selectedTimeSlot &&
    availableResources &&
    availableResources.length > 1
  ) {
    return "resources";
  }

  return recurringBooking ? "recurringBooking" : "availability";
};
